import { useEffect } from "react"

import { Loader } from "@googlemaps/js-api-loader"
import { atom, useRecoilState } from "recoil"

import EnvVars from "../env-vars"

enum GoogleMapsLoaded {
  unloaded = 0,
  loading = 1,
  success = 2,
  error = 3,
}

const googleMapsIsLoadedState = atom<GoogleMapsLoaded>({
  key: `googleMapsIsLoaded`,
  default: GoogleMapsLoaded.unloaded,
})

const useLoadGoogleMaps = (): boolean => {
  const [googleLoaded, setGoogleLoaded] = useRecoilState(googleMapsIsLoadedState)

  useEffect(() => {
    switch (googleLoaded) {
      case GoogleMapsLoaded.unloaded:
        setGoogleLoaded(GoogleMapsLoaded.loading)
        new Loader({
          apiKey: EnvVars.GOOGLE_MAPS_API_KEY as string,
        })
          .load()
          .then(() => {
            setGoogleLoaded(GoogleMapsLoaded.success)
          })
          .catch((e) => {
            setGoogleLoaded(GoogleMapsLoaded.error)
            console.error(e)
          })
        break
      case GoogleMapsLoaded.loading:
        break
      case GoogleMapsLoaded.success:
        break
      case GoogleMapsLoaded.error:
        break
    }
  }, [googleLoaded, setGoogleLoaded])

  return googleLoaded === GoogleMapsLoaded.success
}

export default useLoadGoogleMaps
